import { yupResolver } from "@hookform/resolvers/yup";
import { usePostCalcularValoresDespesaParcelada } from "hooks/contasPagar/usePostCalcularValoresDespesaParcelada";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import React, { useEffect } from "react";
import { FaX } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import { CustomDatePicker } from "shared/components/date/CustomDatePicker";
import CustomNumberInput from "shared/components/input/CustomNumberInput";
import CustomModal from "shared/components/modal/CustomModal";
import { ModalCadastrarDespesaParceladaGroupPaySchema } from "shared/yup/schemas/ModalCadastrarDespesaParceladaSchema";
import { ValoresDespesaParceladaRequest } from "types/request/contasPagar/ValoresDespesaParceladaRequest";
import { ValoresDespesaParceladaResponse } from "types/request/contasPagar/ValoresDespesaParceladaResponse";

interface ModalInformarParcelasGroupPayForm {
  valorTotal: any;
  numeroParcelas: any;
  dataVencimentoPrimeiraParcela: Date;
}

export type DadosParcelamento = {
  parcelas: ValoresDespesaParceladaResponse[];
  valorTotal: number;
};
interface ModalInformarParcelasGroupPayProps {
  showModal: boolean;
  onCloseModal: () => void;
  valorTotalParcelas: number | undefined;
  openModalCadastrarDepesaParcelada: (dadosParcelamento: DadosParcelamento) => void;
  numeroParcelasPadrao?: number;
  dataVencimentoPrimeiraParcelaPadrao?: Date;
}

const ModalInformarParcelasGroupPay: React.FC<ModalInformarParcelasGroupPayProps> = (props) => {
  const { register, control, handleSubmit, setValue, reset, clearErrors } = useForm<ModalInformarParcelasGroupPayForm>({
    resolver: yupResolver<ModalInformarParcelasGroupPayForm>(ModalCadastrarDespesaParceladaGroupPaySchema),
    defaultValues: {
      numeroParcelas: props.numeroParcelasPadrao,
      valorTotal: props.valorTotalParcelas,
      dataVencimentoPrimeiraParcela: props.dataVencimentoPrimeiraParcelaPadrao,
    },
  });

  useEffect(() => {
    if (props.numeroParcelasPadrao) {
      setValue("numeroParcelas", props.numeroParcelasPadrao);
    }
    if (props.valorTotalParcelas) {
      setValue("valorTotal", props.valorTotalParcelas);
    }
    if (props.dataVencimentoPrimeiraParcelaPadrao) {
      setValue("dataVencimentoPrimeiraParcela", props.dataVencimentoPrimeiraParcelaPadrao);
    }
  }, [props.numeroParcelasPadrao, props.valorTotalParcelas, props.dataVencimentoPrimeiraParcelaPadrao, setValue]);

  const { mutateAsync: calcularValoresParcelas } = usePostCalcularValoresDespesaParcelada();

  const renderContentModalInformarParcelas = () => {
    return (
      <div className="p-3">
        <Row>
          {renderCampoNumeroParcelas()}
          {renderCampoDataVencimentoPrimeiraParcela()}
        </Row>
        {renderCampoValorTotal()}
      </div>
    );
  };

  const renderCampoNumeroParcelas = () => {
    return (
      <Col xs={6}>
        <CustomNumberInput
          id="numero-parcelas-modal-informar-parcelas-group-pay"
          name="numeroParcelas"
          label="Número de parcelas *"
          control={control}
          register={register}
          setValue={setValue}
          isAllowed={(valor) => {
            const { floatValue } = valor;
            return floatValue === undefined || (floatValue >= 0 && floatValue <= 72);
          }}
          usarValidacaoParaFormulario
        />
      </Col>
    );
  };

  const renderCampoDataVencimentoPrimeiraParcela = () => {
    return (
      <Col xs={6}>
        <CustomDatePicker
          name="dataVencimentoPrimeiraParcela"
          label="Data de vencimento da primeira parcela *"
          control={control}
          register={register}
          setValue={setValue}
          usarValidacaoParaFormulario
        />
      </Col>
    );
  };

  const renderCampoValorTotal = () => {
    return (
      <Col xs={6} className="mt-3">
        <CustomNumberInput
          id="number-input-valor-total-informar-parcelas-group-pay"
          name="valorTotal"
          label="Valor total (R$) *"
          prefix="R$ "
          control={control}
          setValue={setValue}
          register={register}
          defaultValue={props.valorTotalParcelas}
          isAllowed={(valor) => {
            const { floatValue } = valor;
            return floatValue === undefined || (floatValue >= 0 && floatValue <= 999999999999.99);
          }}
          placeholder="R$ 0,00"
          decimalScale={2}
          usarValidacaoParaFormulario
        />
      </Col>
    );
  };

  const handleSubmitCalcularValoresDespesaParcelada = async (formValues: ModalInformarParcelasGroupPayForm) => {
    const request: ValoresDespesaParceladaRequest = {
      valorTotal: formValues.valorTotal,
      numeroDeParcelas: Number(formValues.numeroParcelas),
      dataVencimentoPrimeiraParcela: formValues.dataVencimentoPrimeiraParcela,
    };

    
    await calcularValoresParcelas(request).then((res) => {
      props.openModalCadastrarDepesaParcelada({
        parcelas: res.payload,
        valorTotal: formValues.valorTotal,
      });
      reset();
    });
  };

  const fecharModal = () => {
    reset();
    clearErrors();
    props.onCloseModal();
  };

  return (
    <CustomModal
      key={"modal-cadastrar-despesa-unica-group-pay"}
      titulo="Lançar conta a pagar - parcelada"
      size="lg"
      tipoModal="MODAL_CENTRAL"
      bodyClassName="p-0"
      fecharModalAoClicarFora={false}
      scrollable
      customFooter={
        <div>
          <CustomButton
            id="btn-cancelar-informar-parcelas-group-pay"
            label="Cancelar"
            onClick={fecharModal}
            variant="danger-alt"
            leftIcon={FaX}
            className="me-3"
          />
          <CustomButton
            id="btn-avancar-cadastro-despesa-parcelada-group-pay"
            label="Avançar"
            onClick={() => handleSubmit(handleSubmitCalcularValoresDespesaParcelada)()}
            variant="primary"
          />
        </div>
      }
      onCloseModal={fecharModal}
      showModal={props.showModal}
    >
      <>{renderContentModalInformarParcelas()}</>
    </CustomModal>
  );
};

export default ModalInformarParcelasGroupPay;
